import axios from 'axios';
import { RequestViewingViewModel } from '@/models/RequestViewingViewModel';
import Auth from '@/auth/Auth';
import UnauthorizedError from '@/auth/UnauthorizedError';

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_ROOT,
    withCredentials: false, // This is the default
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

let token = '';

export default {
    getSoldPoints() {
        return apiClient.get('/api/listings/soldpoints');
    },
    async getListingsDetail(systemId: string, isLoggedIn: boolean) {
        if (isLoggedIn) {
            token = await Auth.getAccessToken();
            if (token) {
                return apiClient.get(`/api/listings/${systemId}`, { headers: {Authorization: `Bearer ${token}`} });
            }
        }
        return apiClient.get(`/api/listings/${systemId}`);
    },
    async getParcelData(pid: string, isLoggedIn: boolean) {
        if (isLoggedIn) {
            token = await Auth.getAccessToken();
            if (token) {
                return apiClient.get(`/api/parcels/${pid}`, { headers: {Authorization: `Bearer ${token}`} });
            }
        }
        return apiClient.get(`/api/parcels/${pid}`);
    },
    async addFavouriteId(sysId: number) {
        token = await Auth.getAccessToken();
        if (token) {
            return apiClient.post('/api/users/myUser/favourites', { systemId: sysId }, { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    async getFavouriteSettings() {
        token = await Auth.getAccessToken();
        if (token) {
            return apiClient.get('/api/users/myUser/favourites/settings', { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    async getFavourites() {
        token = await Auth.getAccessToken();
        if (token) {
            return apiClient.get('/api/users/myUser/favourites', { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    async removeFavourite(sysId: number) {
        token = await Auth.getAccessToken();
        if (token) {
            return apiClient.delete(`/api/users/myUser/favourites/${sysId}`, { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    async setFavouriteNotifications(isOnBool: boolean) {
        token = await Auth.getAccessToken();
        if (token) {
            return apiClient.put('/api/users/myUser/favourites/settings', { isNotifyOn: isOnBool }, { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    async getFilterData() {
        token = await Auth.getAccessToken();
        if (token) {
            return apiClient.get('/api/users/myUser/filters', { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    async saveFilterData(filter: any) {
        token = await Auth.getAccessToken();
        if (token) {
           return apiClient.post('/api/users/myUser/filters', filter, { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    async deleteFilterData(filterId: number) {
        token = await Auth.getAccessToken();
        if (token) {
            return apiClient.delete(`/api/users/myUser/filters/${filterId}`, { headers: {Authorization: `Bearer ${token}`} });
        } else {
            throw new UnauthorizedError('Not logged in');
        }
    },
    requestViewing(remapViewModel: RequestViewingViewModel) {
        return apiClient.post('/api/showing', remapViewModel);
    },
};
